module.exports = __webpack_public_path__ + "img/憨笑.3f6a7e69.gif";